// Практичная проверка формата: локальная часть, @, домен с точкой и TLD от 2 букв.
// Строгий RFC 5322 намеренно не берём. Домен не ограничиваем — пускаем любой.
export const EMAIL_REGEX = /^[^\s@]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

/**
 * Каноничный вид адреса: именно он уезжает на бэк и служит там ключом лимитов.
 *
 * Zero-width и BOM вырезаем везде: они невидимы, в адресе не значат ничего и приезжают
 * из копипаста со свёрстанной страницы. Обычные пробелы (включая NBSP из мобильного
 * автозаполнения) снимаем только по краям — trim по спеке убирает любой пробельный
 * символ. Внутренние пробелы намеренно оставляем: "a b@c.ru" — это опечатка, и её
 * должен отклонить EMAIL_REGEX, а не тихо склеить нормализация.
 * Регистр гасим, чтобы Ivan@Ya.RU и ivan@ya.ru были для бэка одним ключом — иначе
 * лимит на адрес обходится сменой регистра, а аккаунт расщепляется на два.
 */
export function normalizeEmail(value: string): string {
	return value
		.replace(/[\u200b-\u200d\ufeff]/g, '')
		.trim()
		.toLowerCase()
}

export function isValidEmail(value: string): boolean {
	return EMAIL_REGEX.test(normalizeEmail(value))
}
